<template>
  <div id="app">
    <!-- 顶部导航 -->
    <Header></Header>
    <!-- banner图 -->
    <div class="banner">
      <img src="./images/banner.png" alt="">
       <div class="bannerCon">
        <div class="textCon">
          <p class="bigText">{{ copyData.technology.bannerTitleOne }}</p>
          <p class="bigText">{{ copyData.technology.bannerTitleTwo }}</p>
          <p>{{ copyData.technology.bannerTitleThree }}</p>
          <p>{{ copyData.technology.bannerTitleFour }}</p>
        </div>
      </div>
    </div>
    <!-- 面包屑 -->
    <p class="breadcrumb">{{ copyData.technology.breadcrumb }}{{ breadcrumb }}</p>
    <!-- 主体部分 -->
    <div class="main">
      <!-- pc端导航栏 -->
      <div class="leftCon" v-if="windowWidth >= 800">
        <div class="titleCon">
          <p class="title">{{ copyData.technology.technologyTitleZH }}</p>
          <p class="titleEN">{{ copyData.technology.technologyTitleEN }}</p>
        </div>
        <div class="menuCon">
          <div class="menuList" :class="tabTag == 1 ? 'menuListAct' : ''"
               @click="tabTag = 1,breadcrumb = copyData.technology.advantage,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.technology.advantage }}</p>
          </div>
          <div class="menuList" :class="tabTag == 2 ? 'menuListAct' : ''"
               @click="tabTag = 2,breadcrumb = copyData.technology.produce,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.technology.produce }}</p>
          </div>
          <div class="menuList" :class="tabTag == 3 ? 'menuListAct' : ''"
               @click="tabTag = 3,breadcrumb = copyData.technology.detect,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.technology.detect }}</p>
          </div>
          <div class="menuList" :class="tabTag == 4 ? 'menuListAct' : ''"
               @click="tabTag = 4,breadcrumb = copyData.technology.environment,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.technology.environment }}</p>
          </div>
          <div class="phoneCon">
            <img src="./images/phone.png" alt="">
            <p>{{ copyData.technology.phoneTitle }}</p>
            <p class="phoneNum">{{ copyData.technology.phoneNum }}</p>
          </div>
        </div>
      </div>
      <!-- 移动端导航栏 -->
      <div class="leftCon" v-if="windowWidth < 800">
        <div class="menuCon">
          <div class="menuList" :class="tabTag == 1 ? 'menuListAct' : ''"
               @click="tabTag = 1,breadcrumb = copyData.technology.advantage">
            <p>{{ copyData.technology.advantage }}</p>
          </div>
          <div class="menuList" :class="tabTag == 2 ? 'menuListAct' : ''"
               @click="tabTag = 2,breadcrumb = copyData.technology.produce">
            <p>{{ copyData.technology.produce }}</p>
          </div>
          <div class="menuList" :class="tabTag == 3 ? 'menuListAct' : ''"
               @click="tabTag = 3,breadcrumb = copyData.technology.detect">
            <p>{{ copyData.technology.detect }}</p>
          </div>
          <div class="menuList" :class="tabTag == 4 ? 'menuListAct' : ''"
               @click="tabTag = 4,breadcrumb = copyData.about.team">
            <p>{{ copyData.technology.environment }}</p>
          </div>
        </div>
      </div>
      <!-- 技术优势 -->
      <div class="rightConOne" v-if="tabTag == 1 && windowWidth >= 800">
        <div class="rightTop">
          <div class="titleCon">
            <img src="./images/icon.png" alt="">
            <p class="titleZH">{{ copyData.technology.advantageTitleZH }}</p>
            <p class="titleEN">{{ copyData.technology.advantageTitleEN }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.advantageMainTitleOne }}</p>
          <div class="infoList listOne">
            <div class="listHeader">
              <img src="./images/icon01.png" alt="">
              <p>{{ copyData.technology.listTitleOne }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextOne }}</p>
          </div>
          <div class="infoList listOne">
            <div class="listHeader">
              <img src="./images/icon02.png" alt="">
              <p>{{ copyData.technology.listTitleTwo }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextTwo }}</p>
          </div>
          <div class="infoList listOne">
            <div class="listHeader">
              <img src="./images/icon03.png" alt="">
              <p>{{ copyData.technology.listTitleThree }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextThree }}</p>
          </div>
          <div class="infoList listTwo">
            <div class="listHeader">
              <img src="./images/icon04.png" alt="">
              <p v-html="copyData.technology.listTitleFour"></p>
            </div>
            <p class="listText">{{ copyData.technology.listTextFour }}</p>
          </div>
          <div class="infoList listTwo">
            <div class="listHeader">
              <img src="./images/icon05.png" alt="">
              <p>{{ copyData.technology.listTitleFive }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextFive }}</p>
          </div>
          <div class="infoList listTwo">
            <div class="listHeader">
              <img src="./images/icon06.png" alt="">
              <p v-html="copyData.technology.listTitleSix"></p>
            </div>
            <p class="listText">{{ copyData.technology.listTextSix }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.advantageMainTitleTwo }}</p>
          <div class="infoList listSpecial">
            <div class="listHeader">
              <img src="./images/icon07.png" alt="">
              <p v-html="copyData.technology.listTitleSeven"></p>
            </div>
            <div class="infoCon">
              <p>{{
                  copyData.technology.listTextSeven01
                }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ copyData.technology.listTextSeven02 }}</p>
              <p>{{ copyData.technology.listTextSeven07 }}
              <p>{{ copyData.technology.listTextSeven03 }}</p>
              <p>{{ copyData.technology.listTextSeven04 }}</p>
              <p>{{ copyData.technology.listTextSeven05 }}</p>
              <p>{{ copyData.technology.listTextSeven06 }}</p>
            </div>
          </div>
          <div class="infoList listThree">
            <div class="listHeader">
              <img src="./images/icon08.png" alt="">
              <p v-html="copyData.technology.listTitleEight01"></p>
              <p>{{ copyData.technology.listTitleEight02 }}</p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextEight01 }}</p>
              <p>{{ copyData.technology.listTextEight02 }}</p>
              <p>{{ copyData.technology.listTextEight03 }}</p>
            </div>
          </div>
          <div class="infoList listThree">
            <div class="listHeader">
              <img src="./images/icon09.png" alt="">
              <p v-html="copyData.technology.listTitleNine01"></p>
              <p>{{ copyData.technology.listTitleNine02 }}</p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextNine01 }}</p>
              <p>{{ copyData.technology.listTextNine02 }}</p>
              <p>{{ copyData.technology.listTextNine03 }}</p>
              <p>{{ copyData.technology.listTextNine04 }}</p>
            </div>
          </div>
          <div class="infoList listThree">
            <div class="listHeader">
              <img src="./images/icon10.png" alt="">
              <p v-html="copyData.technology.listTitleTen01"></p>
              <p>{{ copyData.technology.listTitleTen02 }}</p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextTen01 }}</p>
              <p>{{ copyData.technology.listTextTen02 }}</p>
              <p>{{ copyData.technology.listTextTen03 }}</p>
              <p>{{ copyData.technology.listTextTen04 }}</p>
            </div>
          </div>
          <div class="infoList listFour">
            <div class="listHeader">
              <img src="./images/icon11.png" alt="">
              <p v-html="copyData.technology.listTitleEle"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextEle01 }}</p>
              <p>{{ copyData.technology.listTextEle02 }}</p>
              <p>{{ copyData.technology.listTextEle03 }}</p>
              <p>{{ copyData.technology.listTextEle04 }}</p>
            </div>
          </div>
          <div class="infoList listFour">
            <div class="listHeader">
              <img src="./images/icon12.png" alt="">
              <p v-html="copyData.technology.listTitleTwe"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextTwe01 }}</p>
              <p>{{ copyData.technology.listTextTwe02 }}</p>
              <p>{{ copyData.technology.listTextTwe03 }}</p>
              <p>{{ copyData.technology.listTextTwe04 }}</p>
              <p>{{ copyData.technology.listTextTwe05 }}</p>
            </div>
          </div>
          <div class="infoList listFour">
            <div class="listHeader">
              <img src="./images/icon13.png" alt="">
              <p v-html="copyData.technology.listTitleThi"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextThi01 }}</p>
              <p>{{ copyData.technology.listTextThi02 }}</p>
              <p>{{ copyData.technology.listTextThi03 }}</p>
              <p>{{ copyData.technology.listTextThi04 }}</p>
              <p>{{ copyData.technology.listTextThi05 }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="rightConOne" v-if="tabTag == 1 && windowWidth < 800">
        <div class="rightTop">
          <div class="titleCon">
            <img src="./images/icon.png" alt="">
            <p class="titleZH">{{ copyData.technology.advantageTitleZH }}</p>
            <p class="titleEN">{{ copyData.technology.advantageTitleEN }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.advantageMainTitleOne }}</p>
          <div class="infoList listOne">
            <div class="listHeader">
              <img src="./images/icon01.png" alt="">
              <p>{{ copyData.technology.listTitleOne }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextOne }}</p>
          </div>
          <div class="infoList listOne">
            <div class="listHeader">
              <img src="./images/icon02.png" alt="">
              <p>{{ copyData.technology.listTitleTwo }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextTwo }}</p>
          </div>
          <div class="infoList listTwo">
            <div class="listHeader">
              <img src="./images/icon03.png" alt="">
              <p>{{ copyData.technology.listTitleThree }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextThree }}</p>
          </div>
          <div class="infoList listTwo">
            <div class="listHeader">
              <img src="./images/icon04.png" alt="">
              <p v-html="copyData.technology.listTitleFour"></p>
            </div>
            <p class="listText">{{ copyData.technology.listTextFour }}</p>
          </div>
          <div class="infoList listThree">
            <div class="listHeader">
              <img src="./images/icon05.png" alt="">
              <p>{{ copyData.technology.listTitleFive }}</p>
            </div>
            <p class="listText">{{ copyData.technology.listTextFive }}</p>
          </div>
          <div class="infoList listThree">
            <div class="listHeader">
              <img src="./images/icon06.png" alt="">
              <p v-html="copyData.technology.listTitleSix"></p>
            </div>
            <p class="listText">{{ copyData.technology.listTextSix }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.advantageMainTitleTwo }}</p>
          <div class="infoList listSpecial">
            <div class="listHeader">
              <img src="./images/icon07.png" alt="">
              <p v-html="copyData.technology.listTitleSeven"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextSeven01 }}</p>
              <p>{{ copyData.technology.listTextSeven02 }}</p>
              <p>{{ copyData.technology.listTextSeven03 }}</p>
              <p>{{ copyData.technology.listTextSeven04 }}</p>
              <p>{{ copyData.technology.listTextSeven05 }}</p>
              <p>{{ copyData.technology.listTextSeven06 }}</p>
            </div>
          </div>
          <div class="infoList listFive">
            <div class="listHeader">
              <img src="./images/icon08.png" alt="">
              <p v-html="copyData.technology.listTitleEight01"></p>
              <p v-html="copyData.technology.listTitleEight02"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextEight01 }}</p>
              <p>{{ copyData.technology.listTextEight02 }}</p>
              <p>{{ copyData.technology.listTextEight03 }}</p>
            </div>
          </div>
          <div class="infoList listFive">
            <div class="listHeader">
              <img src="./images/icon09.png" alt="">
              <p v-html="copyData.technology.listTitleNine01"></p>
              <p>{{ copyData.technology.listTitleNine02 }}</p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextNine01 }}</p>
              <p>{{ copyData.technology.listTextNine02 }}</p>
              <p>{{ copyData.technology.listTextNine03 }}</p>
              <p>{{ copyData.technology.listTextNine04 }}</p>
            </div>
          </div>
          <div class="infoList listSix">
            <div class="listHeader">
              <img src="./images/icon10.png" alt="">
              <p v-html="copyData.technology.listTitleTen01"></p>
              <p>{{ copyData.technology.listTitleTen02 }}</p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextTen01 }}</p>
              <p>{{ copyData.technology.listTextTen02 }}</p>
              <p>{{ copyData.technology.listTextTen03 }}</p>
              <p>{{ copyData.technology.listTextTen04 }}</p>
            </div>
          </div>
          <div class="infoList listSix">
            <div class="listHeader">
              <img src="./images/icon11.png" alt="">
              <p v-html="copyData.technology.listTitleEle"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextEle01 }}</p>
              <p>{{ copyData.technology.listTextEle02 }}</p>
              <p>{{ copyData.technology.listTextEle03 }}</p>
              <p>{{ copyData.technology.listTextEle04 }}</p>
            </div>
          </div>
          <div class="infoList listEleven">
            <div class="listHeader">
              <img src="./images/icon12.png" alt="">
              <p v-html="copyData.technology.listTitleTwe"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextTwe01 }}</p>
              <p>{{ copyData.technology.listTextTwe02 }}</p>
              <p>{{ copyData.technology.listTextTwe03 }}</p>
              <p>{{ copyData.technology.listTextTwe04 }}</p>
              <p>{{ copyData.technology.listTextTwe05 }}</p>
            </div>
          </div>
          <div class="infoList listEleven">
            <div class="listHeader">
              <img src="./images/icon13.png" alt="">
              <p v-html="copyData.technology.listTitleThi"></p>
            </div>
            <div class="infoCon">
              <p>{{ copyData.technology.listTextThi01 }}</p>
              <p>{{ copyData.technology.listTextThi02 }}</p>
              <p>{{ copyData.technology.listTextThi03 }}</p>
              <p>{{ copyData.technology.listTextThi04 }}</p>
              <p>{{ copyData.technology.listTextThi05 }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 生产设备 -->
      <div class="rightConTwo" v-if="tabTag == 2 && windowWidth >= 800">
        <div class="rightTop">
          <div class="titleCon">
            <img src="./images/icon.png" alt="">
            <p class="titleZH">{{ copyData.technology.produceTitleZH }}</p>
            <p class="titleEN">{{ copyData.technology.produceTitleEN }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.produceMainTitleOne }}</p>
          <div class="infoList listOne">
            <img src="./images/produce01.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleOne }}</p>
              <div class="line"></div>
              <p class="text">{{ copyData.technology.produceListTextOne }}</p>
            </div>
          </div>
          <div class="infoList listOne">
            <img src="./images/produce02.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleTwo }}</p>
              <div class="line"></div>
              <p class="text">{{ copyData.technology.produceListTextTwo }}</p>
            </div>
          </div>
          <div class="infoList listOne">
            <img src="./images/produce03.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleThree }}</p>
              <div class="line"></div>
              <p class="text">{{ copyData.technology.produceListTextThree }}</p>
            </div>
          </div>
          <div class="infoList listTwo">
            <img src="./images/produce04.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFour }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFour01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFour02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextFour03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextFour04 }}
              </p>
            </div>
          </div>
          <div class="infoList listTwo">
            <img src="./images/produce05.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFive }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFive01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFive02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextFive03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextFive04 }}
              </p>
            </div>
          </div>
          <div class="infoList listTwo">
            <img src="./images/produce06.png" alt="">
            <div class="listCon">
              <p class="title" v-html="copyData.technology.produceListTitleSix"></p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSix01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSix02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextSix03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextSix04 }}
              </p>
            </div>
          </div>
          <div class="infoList listThree">
            <img src="./images/produce07.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleSeven }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSeven01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSeven02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextSeven03 }}
              </p>
            </div>
          </div>
          <div class="infoList listThree">
            <img src="./images/produce08.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleEight }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextEight01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextEight02 }}
              </p>
            </div>
          </div>
          <div class="infoList listThree">
            <img src="./images/produce09.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleNine }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextNine01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextNine02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextNine03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextNine04 }}
              </p>
            </div>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.produceMainTitleTwo }}</p>
          <div class="infoList listFour">
            <img src="./images/produce10.png" alt="">
            <div class="listCon">
              <div class="listCon">
                <p class="title">{{ copyData.technology.produceListTitleTen }}</p>
                <div class="line"></div>
                <p class="text">
                  <span>{{ copyData.technology.produceTitleNum }}</span>
                  {{ copyData.technology.produceListTextTen01 }}
                </p>
                <p class="text textSpecial">
                  <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                  {{ copyData.technology.produceListTextTen02 }}
                </p>
                <p class="text" v-html="copyData.technology.produceListTextTen03">
                </p>
              </div>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce11.png" alt="">
            <div class="listCon">
              <div class="listCon">
                <p class="title">{{ copyData.technology.produceListTitleEleven }}</p>
                <div class="line"></div>
                <p class="text">
                  <span>{{ copyData.technology.produceTitleNum }}</span>
                  {{ copyData.technology.produceListTextEleven01 }}
                </p>
                <p class="text textSpecial">
                  <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                  {{ copyData.technology.produceListTextEleven02 }}
                </p>
                <p class="text" v-html="copyData.technology.produceListTextEleven03">
                </p>
              </div>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce12.png" alt="">
            <div class="listCon">
              <div class="listCon">
                <p class="title">{{ copyData.technology.produceListTitleTwelve }}</p>
                <div class="line"></div>
                <p class="text">
                  <span>{{ copyData.technology.produceTitleNum }}</span>
                  {{ copyData.technology.produceListTextTwelve01 }}
                </p>
                <p class="text textSpecial">
                  <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                  <p class="text" v-html="copyData.technology.produceListTextTwelve02"></p>
                </p>
              </div>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce13.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleThirteen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextThirteen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextThirteen02 }}
              </p>
              <p class="text" v-html="copyData.technology.produceListTextThirteen03">
              </p>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce14.png" alt="">
            <div class="listCon">
              <p class="title" v-html="copyData.technology.produceListTitleFourteen"></p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFourteen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFourteen02 }}
              </p>
              <p class="text" v-html="copyData.technology.produceListTextFourteen03">
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleDay }}</span>
                {{ copyData.technology.produceListTextFourteen04 }}
              </p>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce15.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFiveTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFiveteen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFiveteen02 }}
              </p>
              <p class="text" v-html="copyData.technology.produceListTextFiveteen03">
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleYear }}</span>
                {{ copyData.technology.produceListTextFiveteen04 }}
              </p>
            </div>
          </div>
          <div class="infoList listOne">
            <img src="./images/produce16.png" alt="">
            <div class="listCon">
              <p class="title" v-html="copyData.technology.produceListTitleSixTeen"></p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSixteen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSixteen02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleDay }}</span>
                {{ copyData.technology.produceListTextSixteen03 }}
              </p>
            </div>
          </div>
          <div class="infoList listOne">
            <img src="./images/produce17.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleSevenTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSeventeen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSeventeen02 }}
              </p>
            </div>
          </div>
          <div class="infoList listOne">
            <img src="./images/produce18.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleEightTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextEightTeen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextEightTeen02 }}
              </p>
            </div>
          </div>
          <div class="infoList listSpecial">
            <img src="./images/produce19.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleNineTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextNineTeen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextNineTeen02 }}
              </p>
              <p class="text">
                {{ copyData.technology.produceListTextNineTeen03 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="rightConTwo" v-if="tabTag == 2 && windowWidth < 800">
        <div class="rightTop">
          <div class="titleCon">
            <img src="./images/icon.png" alt="">
            <p class="titleZH">{{ copyData.technology.produceTitleZH }}</p>
            <p class="titleEN">{{ copyData.technology.produceTitleEN }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.produceMainTitleOne }}</p>
          <div class="infoList listOne">
            <img src="./images/produce01.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleOne }}</p>
              <div class="line"></div>
              <p class="text">{{ copyData.technology.produceListTextOne }}</p>
            </div>
          </div>
          <div class="infoList listOne">
            <img src="./images/produce02.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleTwo }}</p>
              <div class="line"></div>
              <p class="text">{{ copyData.technology.produceListTextTwo }}</p>
            </div>
          </div>
          <div class="infoList listTwo">
            <img src="./images/produce03.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleThree }}</p>
              <div class="line"></div>
              <p class="text">{{ copyData.technology.produceListTextThree }}</p>
            </div>
          </div>
          <div class="infoList listTwo">
            <img src="./images/produce04.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFour }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFour01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFour02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextFour03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextFour04 }}
              </p>
            </div>
          </div>
          <div class="infoList listThree">
            <img src="./images/produce05.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFive }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFive01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFive02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextFive03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextFive04 }}
              </p>
            </div>
          </div>
          <div class="infoList listThree">
            <img src="./images/produce06.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleSix }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSix01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSix02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextSix03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextSix04 }}
              </p>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce07.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleSeven }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSeven01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSeven02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextSeven03 }}
              </p>
            </div>
          </div>
          <div class="infoList listFour">
            <img src="./images/produce08.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleEight }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextEight01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextEight02 }}
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce09.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleNine }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextNine01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextNine02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMain }}</span>
                {{ copyData.technology.produceListTextNine03 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleMonth }}</span>
                {{ copyData.technology.produceListTextNine04 }}
              </p>
            </div>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.produceMainTitleTwo }}</p>
          <div class="infoList listFive">
            <img src="./images/produce10.png" alt="">
            <div class="listCon">
              <div class="listCon">
                <p class="title">{{ copyData.technology.produceListTitleTen }}</p>
                <div class="line"></div>
                <p class="text">
                  <span>{{ copyData.technology.produceTitleNum }}</span>
                  {{ copyData.technology.produceListTextTen01 }}
                </p>
                <p class="text textSpecial">
                  <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                  {{ copyData.technology.produceListTextTen02 }}
                </p>
                <p class="text" v-html="copyData.technology.produceListTextTen03">
                </p>
              </div>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce11.png" alt="">
            <div class="listCon">
              <div class="listCon">
                <p class="title">{{ copyData.technology.produceListTitleEleven }}</p>
                <div class="line"></div>
                <p class="text">
                  <span>{{ copyData.technology.produceTitleNum }}</span>
                  {{ copyData.technology.produceListTextEleven01 }}
                </p>
                <p class="text textSpecial">
                  <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                  {{ copyData.technology.produceListTextEleven02 }}
                </p>
                <p class="text" v-html="copyData.technology.produceListTextEleven03">
                </p>
              </div>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce12.png" alt="">
            <div class="listCon">
              <div class="listCon">
                <p class="title">{{ copyData.technology.produceListTitleTwelve }}</p>
                <div class="line"></div>
                <p class="text">
                  <span>{{ copyData.technology.produceTitleNum }}</span>
                  {{ copyData.technology.produceListTextTwelve01 }}
                </p>
                <p class="text textSpecial">
                  <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                  <p v-html="copyData.technology.produceListTextTwelve02"></p>
                </p>
              </div>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce13.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleThirteen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextThirteen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextThirteen02 }}
              </p>
              <p class="text" v-html="copyData.technology.produceListTextThirteen03">
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce14.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFourteen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFourteen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFourteen02 }}
              </p>
              <p class="text" v-html="copyData.technology.produceListTextFourteen03">

              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleDay }}</span>
                {{ copyData.technology.produceListTextFourteen04 }}
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce15.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleFiveTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextFiveteen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextFiveteen02 }}
              </p>
              <p class="text" v-html="copyData.technology.produceListTextFiveteen03">
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleYear }}</span>
                {{ copyData.technology.produceListTextFiveteen04 }}
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce16.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleSixTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSixteen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSixteen02 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleDay }}</span>
                {{ copyData.technology.produceListTextSixteen03 }}
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce17.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleSevenTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextSeventeen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextSeventeen02 }}
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce18.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleEightTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextEightTeen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextEightTeen02 }}
              </p>
            </div>
          </div>
          <div class="infoList listFive">
            <img src="./images/produce19.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.produceListTitleNineTeen }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.produceTitleNum }}</span>
                {{ copyData.technology.produceListTextNineTeen01 }}
              </p>
              <p class="text textSpecial">
                <span>{{ copyData.technology.produceTitleSpecialty }}</span>
                {{ copyData.technology.produceListTextNineTeen02 }}
              </p>
              <p class="text">
                {{ copyData.technology.produceListTextNineTeen03 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 检测设备 -->
      <div class="rightConThree" v-if="tabTag == 3">
        <div class="rightTop">
          <div class="titleCon">
            <img src="./images/icon.png" alt="">
            <p class="titleZH">{{ copyData.technology.detectTitleZH }}</p>
            <p class="titleEN">{{ copyData.technology.detectTitleEN }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.detectMainTitleOne }}</p>
          <div class="infoList">
            <img src="./images/detect01.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleOne }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandOne }}
              </p>
              <p class="text">{{ copyData.technology.detectTextOne }}</p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect02.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleTwo }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextTwo01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandTwo }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextTwo02 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect03.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleThree }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextThree01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandThree }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextThree02 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect04.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleFour }}</p>
              <div class="line lineSpecial"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextFour01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandFour }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextFour02 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect05.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleFive }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandFive }}
              </p>
              <p class="text">{{ copyData.technology.detectTextFive }}</p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect06.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleSix }}</p>
              <div class="line lineSpecial"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextSix01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandSix }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextSix02 }}
              </p>
            </div>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.detectMainTitleTwo }}</p>
          <div class="infoList">
            <img src="./images/detect07.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleSeven }}</p>
              <div class="line lineSpecial"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextSeven01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandSeven }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextSeven03 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect08.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleEight }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextEight01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandEight }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextEight03 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect09.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleNine }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextNine01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandNine }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextNine02 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect10.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleTen }}</p>
              <div class="line lineSpecial"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextTen01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandTen }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextTen03 }}
              </p>
            </div>
          </div>
          <div class="infoList">
            <img src="./images/detect11.png" alt="">
            <div class="listCon">
              <p class="title">{{ copyData.technology.detectTitleEleven }}</p>
              <div class="line"></div>
              <p class="text">
                <span>{{ copyData.technology.detectNum }}</span>
                {{ copyData.technology.detectTextEleven01 }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectBrand }}</span>
                {{ copyData.technology.detectBrandEleven }}
              </p>
              <p class="text">
                <span>{{ copyData.technology.detectRange }}</span>
                {{ copyData.technology.detectTextEleven02 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 车间环境 -->
      <div class="rightConFour" v-if="tabTag == 4">
        <div class="rightTop">
          <div class="titleCon">
            <img src="./images/icon.png" alt="">
            <p class="titleZH">{{ copyData.technology.environmentTitleZH }}</p>
            <p class="titleEN">{{ copyData.technology.environmentTitleEN }}</p>
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.environmentMainTitleOne }}</p>
          <div class="infoList listOne" @click="imgIndex = 0">
            <img src="./images/env01.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 1">
            <img src="./images/env02.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 2">
            <img src="./images/env03.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 3">
            <img src="./images/env04.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 4">
            <img src="./images/env05.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 5">
            <img src="./images/env06.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 6">
            <img src="./images/env07.png" alt="">
          </div>
        </div>
        <div class="rightMain">
          <p class="mainTitle">{{ copyData.technology.environmentMainTitleTwo }}</p>
          <div class="infoList listTwo" @click="imgIndex = 10">
            <img src="./images/env11.png" alt="">
            <p>{{ copyData.technology.environmentTextOne }}</p>
          </div>
          <div class="infoList listTwo" @click="imgIndex = 11">
            <img src="./images/env12.png" alt="">
            <p>{{ copyData.technology.environmentTextTwo }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 12">
            <img src="./images/env13.png" alt="">
            <p>{{ copyData.technology.environmentTextThree }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 13">
            <img src="./images/env14.png" alt="">
            <p>{{ copyData.technology.environmentTextFour }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 14">
            <img src="./images/env15.png" alt="">
            <p>{{ copyData.technology.environmentTextFive }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 7">
            <img src="./images/env08.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 8">
            <img src="./images/env09.png" alt="">
          </div>
          <div class="infoList" @click="imgIndex = 9">
            <img src="./images/env10.png" alt="">
          </div>
          <div class="infoList listThree" @click="imgIndex = 15">
            <img src="./images/env16.png" alt="">
            <p>{{ copyData.technology.environmentTextSix }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 16">
            <img src="./images/env17.png" alt="">
            <p>{{ copyData.technology.environmentTextSeven }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 17">
            <img src="./images/env18.png" alt="">
            <p>{{ copyData.technology.environmentTextEight }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 18">
            <img src="./images/env19.png" alt="">
            <p>{{ copyData.technology.environmentTextNine }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 19">
            <img src="./images/env20.png" alt="">
            <p>{{ copyData.technology.environmentTextTen }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 20">
            <img src="./images/env21.png" alt="">
            <p>{{ copyData.technology.environmentTextEleven }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 21">
            <img src="./images/env22.png" alt="">
            <p>{{ copyData.technology.environmentTextTwelve }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 22">
            <img src="./images/env23.png" alt="">
            <p>{{ copyData.technology.environmentTextThirteen }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 23">
            <img src="./images/env24.png" alt="">
            <p>{{ copyData.technology.environmentTextFourteen }}</p>
          </div>
          <div class="infoList" @click="imgIndex = 24">
            <img src="./images/env25.png" alt="">
            <p>{{ copyData.technology.environmentTextFifteen }}</p>
          </div>
          <div class="infoList listTwo" @click="imgIndex = 25">
            <img src="./images/env26.png" alt="">
            <p>{{ copyData.technology.environmentTextSixteen }}</p>
          </div>
          <div class="infoList listTwo" @click="imgIndex = 26">
            <img src="./images/env27.png" alt="">
            <p>{{ copyData.technology.environmentTextSeventeen }}</p>
          </div>
        </div>
        <!-- 弹窗 -->
        <div class="popCon" v-if="flase" @click="imgIndex = -1">
          <img :src="imgList[imgIndex].url" alt="">
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <Footer></Footer>
    <div class="scroll-top" @click="backToTop">
      <img src="./images/backTop.png">
    </div>
  </div>
</template>

<script>
import 'common/css/reset.css';
import {defineComponent, ref, reactive, onMounted} from "vue";
import Footer from 'components/Footer/Footer'
import Header from 'components/Header/Header'
import {chinese} from "../../language/zh";
import {english} from "../../language/en";

export default defineComponent({
  name: 'app',
  components: {
    Footer,
    Header,
  },

  setup() {
    const copyData = ref({})
    // 获取当前语言
    const getLanguage = () => {
      copyData.value = english
    }
    // 获取当前屏幕的宽度
    const windowWidth = ref(document.body.clientWidth);

    // 获取URL参数
    const breadcrumb = ref('')

    const tabTag = ref(0)
    const getQueryString = () => {
      const arr = window.location.search;
      const strs = arr.split("?")[1];
      const paramt = strs.split("&");
      const obj = {};
      for (let i = 0; i < paramt.length; i++) {
        let g = paramt[i].split("=");
        obj[g[0]] = g[1];
      }
      tabTag.value = obj.id
      if (tabTag.value == 1) {
        breadcrumb.value = copyData.value.footerEchnicalAdvantages
      } else if (tabTag.value == 2) {
        breadcrumb.value = copyData.value.footerProductionEquipment
      } else if (tabTag.value == 3) {
        breadcrumb.value = copyData.value.footerInspectionEquipment
      } else if (tabTag.value == 4) {
        breadcrumb.value = copyData.value.footerWorkshopEnvironment
      }
    }

    const imgIndex = ref(-1)
    const imgList = [
      {url: require('./images/env01.png')},
      {url: require('./images/env02.png')},
      {url: require('./images/env03.png')},
      {url: require('./images/env03.png')},
      {url: require('./images/env05.png')},
      {url: require('./images/env06.png')},
      {url: require('./images/env06.png')},
      {url: require('./images/env08.png')},
      {url: require('./images/env09.png')},
      {url: require('./images/env10.png')},
      {url: require('./images/env11.png')},
      {url: require('./images/env12.png')},
      {url: require('./images/env13.png')},
      {url: require('./images/env14.png')},
      {url: require('./images/env15.png')},
      {url: require('./images/env16.png')},
      {url: require('./images/env17.png')},
      {url: require('./images/env18.png')},
      {url: require('./images/env19.png')},
      {url: require('./images/env20.png')},
      {url: require('./images/env21.png')},
      {url: require('./images/env21.png')},
      {url: require('./images/env21.png')},
      {url: require('./images/env24.png')},
      {url: require('./images/env25.png')},
      {url: require('./images/env26.png')},
      {url: require('./images/env27.png')},
    ]

    // 页面定位到指定位置
    const getPosition = () => {
      if (windowWidth.value >= 800) {
        if (document.body.scrollTop > 750 || document.documentElement.scrollTop > 750) {
          document.body.scrollTop = 750;
          document.documentElement.scrollTop = 750;
        }
      } else {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    };

    const goBackToTop = () => {
      window.addEventListener('scroll', (e) => {
        handleShowTop()
      })
      handleShowTop()


    }

    const handleShowTop = () => {
      let sc = window.scrollY
      if (sc > 100) {
        document.querySelector('.scroll-top').classList.add('show')
      } else {
        document.querySelector('.scroll-top').classList.remove('show')
      }
    }

    const backToTop = () => {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    }

    getLanguage()
    getQueryString()
    breadcrumb.value = copyData.value.footerEchnicalAdvantages

    onMounted(() => {
      goBackToTop()
    });

    return {
      chinese,
      english,
      copyData,
      getLanguage,
      windowWidth,
      breadcrumb,
      tabTag,
      getQueryString,
      imgIndex,
      imgList,
      getPosition,
      goBackToTop,
      backToTop
    }
  }
})
</script>

<style scoped lang="less">
// 电脑端样式
#app {
  font-family: 'SourceHanSansCN', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  overflow-x: hidden;

  .scroll-top {
    display: none;

    &.show {
      position: fixed;
      right: 20px;
      bottom: 100px;
      background: rgba(0,0,0,.4);
      border-radius: 50%;
      height: 50px;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img{
        width: 40px;
        height: 40px;
      }
    }
  }

  p {
    margin: 0;
  }

  .banner {
    width: 100%;
    position: relative;
    z-index: -1;

    img {
      width: 100%;
      height: auto;
    }

    .bannerCon {
      width: 1200px;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      font-size: 20px;
      font-family: 'SourceHanSansCN';
      font-weight: 400;
      color: #FFFFFF;
      text-align: left;

      .textCon {

        p {
          line-height: 40px;
        }

        .bigText {
          font-size: 60px;
          line-height: 80px;
        }

        .bigText:nth-child(2) {
          margin-bottom: 20px;
        }
      }
    }
  }

  .breadcrumb {
    width: 1200px;
    text-align: left;
    font-size: 14px;
    font-family: 'SourceHanSansCN';
    font-weight: 400;
    color: #898989;
    margin: 20px auto 50px;
  }

  .main {
    width: 1200px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;

    .leftCon {
      width: 270px;
      height: 580px;
      margin-right: 50px;

      .titleCon {
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #0068B7;

        .title {
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #FFFFFF;
          margin: 0;
        }

        .titleEN {
          font-size: 12px;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #FFFFFF;
          opacity: 0.5;
          margin: 5px 0 0;
        }
      }

      .menuCon {
        width: 270px;
        height: 470px;
        box-sizing: border-box;
        padding-top: 20px;
        border: 1px solid hsla(240, 1%, 71%, 0.5);
        border-top: none;

        .menuList {
          width: 220px;
          height: 65px;
          border-bottom: 1px solid hsla(240, 1%, 71%, 0.5);
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #595757;
          cursor: pointer;
          margin: 0 auto;

          p {
            margin: 0;
          }

          img {
            margin-right: 17px;
            width: 24px;
            height: 24px;
          }
        }

        .menuList:hover {
          color: #0068B7;
        }

        .menuListAct {
          color: #0068B7;
        }

        .phoneCon {
          width: 220px;
          position: relative;
          font-size: 16px;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #595757;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 10px auto 0;

          p {
            margin: 18px 0;
          }

          img {
            margin-right: 17px;
            width: 24px;
            height: 24px;
          }

          .phoneNum {
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #0068B7;
            position: absolute;
            left: 30px;
            top: 45px;
            width: 200px;
            margin: 0;
          }
        }
      }
    }

    .rightConOne {
      width: 880px;
      margin-bottom: 120px;

      .rightTop {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .titleCon {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 15px;

          img {
            margin-right: 8px;
          }

          p {
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            margin: 0;
          }

          .titleEN {
            font-size: 10px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #E5E5E6;
            width: 80px;
            text-align: left;
            margin-left: 8px;
          }
        }
      }

      .rightMain {
        width: 880px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 15px;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #595757;
        line-height: 25px;
        margin-bottom: 60px;

        .mainTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #595757;
          line-height: 30px;
          margin-bottom: 25px;
        }

        .infoList {
          width: 280px;
          border: 1px solid #E4E4E6;
          border-radius: 10px;
          margin-bottom: 20px;

          .listHeader {
            width: 280px;
            height: 140px;
            background: #F7F8F8;
            border-radius: 10px 10px 0px 0px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            line-height: 30px;
            margin-bottom: 20px;

            img {
              width: 68px;
              height: 68px;
              margin-bottom: 5px;
            }
          }

          .listText {
            width: 240px;
            text-indent: 2em;
            text-align: justify;
            margin: 0 auto;
          }

          .infoCon {
            width: 238px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            text-indent: -1.35em;
            text-align: left;
            margin: 0 auto;

            p {
              margin: 3px 0 3px 1.35em;
            }
          }
        }

        .listOne {
          height: 420px;
        }

        .listTwo {
          height: 366px;
        }

        .listThree {
          height: 331px;

          .listHeader {
            height: 170px;
          }
        }

        .listFour {
          height: 371px;
        }

        .listSpecial {
          width: 879px;
          height: 190px;
          display: flex;
          flex-direction: row;

          .listHeader {
            width: 280px;
            height: 190px;
            background: #F7F8F8;
            border-radius: 10px 0px 0px 10px;
            margin-bottom: 0;
            margin-right: 30px;
          }

          .infoCon {
            width: 537px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            text-indent: 0;
            text-align: left;

            p {
              margin: 3px 0;
            }
          }
        }
      }
    }

    .rightConTwo {
      width: 880px;
      margin-bottom: 120px;

      .rightTop {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .titleCon {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 15px;

          img {
            margin-right: 8px;
          }

          p {
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            margin: 0;
          }

          .titleEN {
            font-size: 10px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #E5E5E6;
            width: 80px;
            text-align: left;
            margin-left: 8px;
          }
        }
      }

      .rightMain {
        width: 880px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 15px;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #595757;
        line-height: 25px;
        margin-bottom: 60px;

        .mainTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #595757;
          line-height: 30px;
          margin-bottom: 25px;
        }

        .infoList {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          font-size: 15px;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #595757;
          line-height: 25px;
          border: 1px solid #E4E4E6;
          border-radius: 10px;
          margin-bottom: 20px;

          img {
            width: 281px;
            height: auto;
            margin-bottom: 20px;
          }

          .listCon {
            width: 281px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;

            .title {
              font-size: 20px;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #0068B7;
            }

            .line {
              width: 240px;
              height: 1px;
              background: #B5B5B6;
              opacity: 0.5;
              margin: 15px 0;
            }

            .text {
              width: 240px;
              text-align: justify;
              margin-bottom: 8px;
            }

            .textSpecial {
              margin-bottom: 0px;
            }

            span {
              color: #0068B7;
              font-weight: 600;
            }
          }
        }

        .listOne {
          height: 400px;
        }

        .listTwo {
          height: 580px;
        }

        .listThree {
          height: 460px;
        }

        .listFour {
          height: 445px;
        }

        .listSpecial {
          width: 880px;
          height: 181px;
          flex-direction: row;

          img {
            margin-bottom: 0;
            margin-right: 40px;
          }

          .listCon {
            width: 500px;
            align-items: flex-start;

            .text {
              width: 100%;
            }
          }
        }
      }
    }

    .rightConThree {
      width: 880px;
      margin-bottom: 120px;

      .rightTop {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .titleCon {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 15px;

          img {
            margin-right: 8px;
          }

          p {
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            margin: 0;
          }

          .titleEN {
            font-size: 10px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #E5E5E6;
            width: 80px;
            text-align: left;
            margin-left: 8px;
          }
        }
      }

      .rightMain {
        width: 880px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 15px;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #595757;
        line-height: 25px;
        margin-bottom: 60px;

        .mainTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #595757;
          line-height: 30px;
          margin-bottom: 25px;
        }

        .infoList {
          width: 880px;
          height: 170px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 1px dashed #DCDCDD;
          margin-bottom: 20px;
          font-size: 15px;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #595757;
          line-height: 25px;
          text-align: left;

          .listCon {
            width: 680px;
            height: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .title {
              font-size: 20px;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #0068B7;
            }

            .line {
              width: 679px;
              height: 1px;
              background: #B5B5B6;
              opacity: 0.5;
              margin: 20px 0;
            }

            .lineSpecial {
              margin: 10px 0;
            }

            span {
              color: #0068B7;
              font-weight: 600;
            }
          }
        }
      }
    }

    .rightConFour {
      width: 880px;
      margin-bottom: 120px;

      .rightTop {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .titleCon {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 15px;

          img {
            margin-right: 8px;
          }

          p {
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            margin: 0;
          }

          .titleEN {
            font-size: 10px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #E5E5E6;
            width: 80px;
            text-align: left;
            margin-left: 8px;
          }
        }
      }

      .rightMain {
        width: 880px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 15px;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #595757;
        line-height: 25px;
        margin-bottom: 60px;

        .mainTitle {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #595757;
          line-height: 30px;
          margin-bottom: 25px;
        }

        .infoList {
          width: 280px;
          height: 180px;
          position: relative;
          margin-bottom: 20px;
          overflow: hidden;
          border-radius: 10px;

          img {
            width: 100%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: width 0.3s;
          }

          img:hover {
            width: 110%;
            height: auto;
            transition: width 0.3s;
          }

          p {
            width: 100%;
            height: 30px;
            background: #0068B7;
            opacity: 0.8;
            border-radius: 0px 0px 10px 10px;
            font-size: 15px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
            text-align: center;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }

        .listOne {
          width: 880px;
          height: 300px;
        }

        .listTwo {
          width: 430px;
          height: 250px;
        }

        .listThree {
          width: 880px;
          height: 180px;
        }
      }

      .popCon {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: hsla(0, 0%, 0%, 0.5);

        img {
          height: 500px;
          width: auto;
        }
      }
    }
  }
}

html[lang="en"] {
  #app {
    .main {
      .rightConOne {
        .rightMain {
          .infoList {
            .listHeader {
              font-size: 13px;
              line-height: 20px;

              img {
                width: 60px;
                height: auto;
              }
            }

            .infoCon{
              p{
                font-size: 14px;
                line-height: 25px;
              }
            }

            .listText {
              font-size: 14px;
              line-height: 20px;
              text-align: center;
              text-indent: 0;
            }
          }

          .listOne {
            height: 691px;
          }

          .listTwo {
            height: 431px;
          }

          .listThree {
            height: 450px;
          }

          .listFour {
            height: 542px;
          }

          .listSpecial {
            height: 300px;
            font-size: 14px;
            line-height: 20px;

            .listHeader {
              height: 100%;
            }

            .infoCon p{
              margin: 3px 0 0 1.35rem;
              text-indent: -1.35em;
            }
          }
        }
      }

      .rightConTwo {
        .rightMain {
          .infoList {
            .listCon {

              .title {
                font-size: 14px;
                line-height: 20px;
              }

              .text {
                font-size: 14px;
                line-height: 20px;
                text-align: left;
              }
            }
          }

          .listOne {
            height: 482px;
          }

          .listTwo {
            height: 728px;
          }

          .listThree {
            height: 510px;
          }

          .listFour {
            height: 509px;
          }
        }
      }

      .rightConThree {
        .rightMain {
          .infoList {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }

      .leftCon {
        .menuCon {
          .menuList {
            font-size: 14px;
          }

          .phoneCon {
            font-size: 14px;

            .phoneNum{
              font-size: 22px;
              text-align: left;
            }

            img {
              margin-right: 9px;
              width: 22px;
              height: 22px;
            }
          }
        }
      }
    }

    .banner{
      .bannerCon{
        .textCon{
          .bigText{
            font-size: 45px;
            text-align: right;
          }

          p{
            text-align: right;
          }
        }
      }
    }
  }
}


// 手机端样式
@media screen and (max-width: 900px) {
  #app {
    font-family: 'SourceHanSansCN', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

    p {
      margin: 0;
    }

    .banner {
      width: 100%;
      height: 55vw;
      overflow: hidden;
      position: relative;

      img {
        width: auto;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .bannerCon {
        width: 80vw;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        font-size: 3.2vw;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #FFFFFF;

        .textCon {
          p {
            line-height: 5vw;
            text-align: right;
          }

          .bigText {
            font-size: 4.8vw;
            line-height: 7vw;
          }

          .bigText:nth-child(2) {
            margin-bottom: 3vw;
          }
        }
      }
    }

    .breadcrumb {
      width: 90vw;
      text-align: left;
      font-size: 3.2vw;
      font-family: 'SourceHanSansCN';
      font-weight: 400;
      color: #898989;
      margin: 3vw auto 3vw;
    }

    .main {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin: 0 auto;

      .leftCon {
        width: 100%;
        margin-right: 0px;
        height: auto;
        margin-bottom: 4vw;

        .menuCon {
          width: 100%;
          height: 12vw;
          box-sizing: border-box;
          padding-top: 0px;
          border: 1px solid hsla(240, 1%, 71%, 0.5);
          border-left: none;
          border-right: none;
          display: flex;
          justify-content: center;
          align-items: center;

          .menuList {
            width: 20vw;
            border-bottom: none;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 3.8vw;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            cursor: pointer;
            margin: 0 auto;

            p {
              margin: 0;
            }
          }

          .menuList:hover {
            color: #0068B7;
          }

          .menuListAct {
            color: #0068B7;
          }

          .phoneCon {
            width: 220px;
            position: relative;
            font-size: 16px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 0 auto;

            img {
              margin-right: 17px;
              width: 24px;
              height: 24px;
            }

            .phoneNum {
              font-size: 24px;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #0068B7;
              position: absolute;
              left: 30px;
              top: 45px;
              width: 200px;
              margin: 0;
            }
          }
        }
      }

      .rightConOne {
        width: 90vw;
        margin-bottom: 10vw;

        .rightTop {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .titleCon {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 4vw;

            img {
              margin-right: 1vw;
              height: 8vw;
              will-change: auto;
            }

            p {
              font-size: 4.27vw;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #595757;
              margin: 0;
            }

            .titleEN {
              font-size: 2vw;
              font-family: 'SourceHanSansCN';
              font-weight: 400;
              color: #E5E5E6;
              width: 55px;
              text-align: left;
              margin-left: 1vw;
            }
          }
        }

        .rightMain {
          width: 90vw;
          margin-bottom: 5vw;

          .mainTitle {
            width: 100%;
            text-align: center;
            font-size: 5vw;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            line-height: 8vw;
            margin-bottom: 3vw;
          }

          .infoList {
            width: 43vw;
            border: 1px solid #E4E4E6;
            border-radius: 2vw;
            margin-bottom: 2vw;

            .listHeader {
              width: 43vw;
              height: 21.5vw;
              background: #F7F8F8;
              border-radius: 10px 10px 0px 0px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 3vw;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #595757;
              line-height: 4vw;
              margin-bottom: 2vw;

              img {
                width: 10vw;
                height: 10vw;
                margin-bottom: 1vw;
              }
            }

            .listText {
              font-size: 3.2vw;
              line-height: 5vw;
              width: 39vw;
              text-indent: 2em;
              text-align: justify;
              margin: 0 auto;
            }

            .infoCon {
              width: 39vw;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              text-indent: 0;
              text-align: left;
              margin: 0 auto;
              font-size: 3.2vw;
              line-height: 5vw;

              p {
                margin: 3px 0;
                text-indent: -1.35rem;
                margin-left: 1.35rem;
              }
            }
          }

          .listOne {
            height: 90vw;
          }

          .listTwo {
            height: 85vw;
          }

          .listThree {
            height: 75vw;
            //  .listHeader {
            //   height: 170px;
            //  }
          }

          .listFour {
            height: 371px;
          }

          .listFive {
            height: 65vw;
          }

          .listSix {
            height: 70vw;
          }

          .listEleven {
            height: 82vw;
          }

          .listSpecial {
            width: 90vw;
            height: 70vw;
            display: flex;
            flex-direction: row;

            .listHeader {
              width: 30vw;
              height: 70vw;
              background: #F7F8F8;
              border-radius: 2vw 0px 0px 2vw;
              margin-bottom: 0;
              margin-right: 5vw;
            }

            .infoCon {
              width: 50vw;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              text-indent: 0;
              text-align: left;

              p {
                margin: 3px 0;
              }
            }
          }
        }
      }

      .rightConTwo {
        width: 90vw;
        margin-bottom: 10vw;

        .rightTop {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .titleCon {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 4vw;

            img {
              margin-right: 1vw;
              height: 8vw;
              will-change: auto;
            }

            p {
              font-size: 4.27vw;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #595757;
              margin: 0;
            }

            .titleEN {
              font-size: 2vw;
              font-family: 'SourceHanSansCN';
              font-weight: 400;
              color: #E5E5E6;
              width: 55px;
              text-align: left;
              margin-left: 1vw;
            }
          }
        }

        .rightMain {
          width: 90vw;
          margin-bottom: 5vw;

          .mainTitle {
            width: 100%;
            text-align: center;
            font-size: 5vw;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            line-height: 8vw;
            margin-bottom: 3vw;
          }

          .infoList {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            font-size: 3.2vw;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            line-height: 4.5vw;
            border: 1px solid #E4E4E6;
            border-radius: 2vw;
            margin-bottom: 3vw;

            img {
              width: 43vw;
              height: auto;
              margin-bottom: 2vw;
            }

            .listCon {
              width: 43vw;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;

              .title {
                font-size: 3.5vw;
                font-family: 'SourceHanSansCN';
                font-weight: bold;
                color: #0068B7;
              }

              .line {
                width: 40vw;
                height: 1px;
                background: #B5B5B6;
                opacity: 0.5;
                margin: 2vw 0;
              }

              .text {
                width: 40vw;
                text-align: justify;
                margin-bottom: 1.5vw;
              }

              .textSpecial {
                margin-bottom: 0px;
              }

              span {
                color: #0068B7;
                font-weight: 600;
              }
            }
          }

          .listOne {
            height: 63vw;
          }

          .listTwo {
            height: 107vw;
          }

          .listThree {
            height: 85vw;
          }

          .listFour {
            height: 78vw;
          }

          .listFive {
            height: 72vw;
          }
        }
      }

      .rightConThree {
        width: 90vw;
        margin-bottom: 10vw;

        .rightTop {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .titleCon {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 4vw;

            img {
              margin-right: 1vw;
              height: 8vw;
              will-change: auto;
            }

            p {
              font-size: 4.27vw;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #595757;
              margin: 0;
            }

            .titleEN {
              font-size: 2vw;
              font-family: 'SourceHanSansCN';
              font-weight: 400;
              color: #E5E5E6;
              width: 55px;
              text-align: left;
              margin-left: 1vw;
            }
          }
        }

        .rightMain {
          width: 90vw;
          margin-bottom: 5vw;

          .mainTitle {
            width: 100%;
            text-align: center;
            font-size: 5vw;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            line-height: 8vw;
            margin-bottom: 3vw;
          }

          .infoList {
            width: 90vw;
            height: auto;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            border-bottom: 1px dashed #DCDCDD;
            margin-bottom: 5vw;
            font-size: 3.2vw;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            line-height: 4.5vw;
            text-align: left;
            padding-bottom: 3vw;

            img {
              height: 25vw;
              width: auto;
            }

            .listCon {
              width: 55vw;
              height: auto;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;

              .title {
                font-size: 4vw;
                font-family: 'SourceHanSansCN';
                font-weight: bold;
                color: #0068B7;
              }

              .line {
                width: 55vw;
                height: 1px;
                background: #B5B5B6;
                opacity: 0.5;
                margin: 2vw 0;
              }

              .lineSpecial {
                margin: 2vw 0;
              }

              span {
                color: #0068B7;
                font-weight: 600;
              }
            }
          }
        }
      }

      .rightConFour {
        width: 90vw;
        margin-bottom: 10vw;

        .rightTop {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .titleCon {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 4vw;

            img {
              margin-right: 1vw;
              height: 8vw;
              will-change: auto;
            }

            p {
              font-size: 4.27vw;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #595757;
              margin: 0;
            }

            .titleEN {
              font-size: 2vw;
              font-family: 'SourceHanSansCN';
              font-weight: 400;
              color: #E5E5E6;
              width: 55px;
              text-align: left;
              margin-left: 1vw;
            }
          }
        }

        .rightMain {
          width: 90vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-start;
          font-size: 3.2vw;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #595757;
          line-height: 4.5vw;
          margin-bottom: 5vw;

          .mainTitle {
            width: 100%;
            text-align: center;
            font-size: 5vw;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #595757;
            line-height: 8vw;
            margin-bottom: 3vw;
          }

          .infoList {
            width: 28vw;
            height: 18vw;
            position: relative;
            margin-bottom: 3vw;
            overflow: hidden;
            border-radius: 2vw;

            img {
              width: 100%;
              height: auto;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              transition: width 0.3s;
            }

            img:hover {
              width: 110%;
              height: auto;
              transition: width 0.3s;
            }

            p {
              width: 100%;
              height: 4.5vw;
              background: #0068B7;
              opacity: 0.8;
              border-radius: 0px 0px 2vw 2vw;
              font-size: 3vw;
              font-family: 'SourceHanSansCN';
              font-weight: 400;
              color: #FFFFFF;
              line-height: 4.5vw;
              text-align: center;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }

          .listOne {
            width: 90vw;
            height: 30.682vw;
          }

          .listTwo {
            width: 43vw;
            height: 25vw;
          }

          .listThree {
            width: 90vw;
            height: 18.41vw;
          }
        }

        .popCon {
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: hsla(0, 0%, 0%, 0.5);

          img {
            height: auto;
            width: 90vw;
          }
        }
      }
    }
  }

  html[lang="en"] {
    #app {
      .main {
        .rightConOne {
          .rightMain {
            .infoList {
              .listHeader {
                height: auto;
              }
            }

            .listOne {
              height: 258vw;
            }

            .listTwo {
              height: 190vw;
            }

            .listThree {
              height: 140vw;
            }

            .listFour {
              height: 560px;
            }

            .listSpecial {
              height: 140vw;

              .listHeader {
                height: 100%;
              }
            }

            .listFive{
              height: 167vw;
            }

            .listSix{
              height: 196vw;
            }

            .listEleven{
              height: 173vw;
            }
          }
        }

        .rightConTwo {
          .rightMain {

            .listOne {
              height: 123vw;
            }

            .listTwo {
              height: 231vw;
            }

            .listThree {
              height: 164vw;
            }

            .listFour {
              height: 145vw;
            }

            .listFive{
              height: 139vw;
            }
          }
        }

        .rightConThree {
          .rightMain {
            .infoList {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }

        .leftCon {
          .menuCon {
            .menuList {
              font-size: 14px;
            }

            .phoneCon {
              font-size: 14px;

              img {
                margin-right: 9px;
                width: 22px;
                height: 22px;
              }
            }
          }
        }
      }

      .banner {
        .bannerCon{
          .textCon{
            .bigText{
              font-size: 18px;
            }

            p{
              font-size: 3vw;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?0fb228df